var exports = {
  "mj": "userInput__l-g6cr",
  "f1": "copilotStart__Fd7Tw6",
  "Ku": "copilotRun__9mVk_y",
  "KA": "copilotEnd__5UjYiX",
};

module.exports = exports;
